import {DateOnlyIsoString} from '@aviary/store/common/common.types';
import {toDateOnly} from '@aviary/store/common/date.helpers';
import {ItemRequestComment, ItemRequestCommentByDate} from '@store/item-requests/item-requests.types';
import {createdCompare} from '@aviary/store/common/typing.helpers';

export function sortedCommentsByDate(comments: ItemRequestComment[]): ItemRequestCommentByDate[] {
  const sortedComments = [...comments].sort(createdCompare)
  // this gives an object with dates as keys
  const groups = sortedComments.reduce((groups, comment) => {
    const date: DateOnlyIsoString = toDateOnly(comment.created);
    return {
      ...groups,
      [date]: [...(groups[date] ?? []), comment]
    };
  }, {});
  return Object.keys(groups).map((date) => ({date, comments: groups[date]}));
}
